import axios from 'axios'
// import qs from 'qs'

export const ssoConfigurationService = ({
  setUpNewSSO (token, formDataObj) {
    return axios.post('/api/SSOConfig/Create', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getSSOList (token) {
    return axios.get('/api/SSOConfigs', {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteSSO (token, ssoConfigId) {
    return axios.delete('/api/SSOConfig/Delete?ssoConfigId=' + ssoConfigId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateSSO (token, formDataObj) {
    return axios.put('/api/SSOConfig/Update', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/sso-configuration-service.js